import React from 'react';
import './Users.css';

const Users = () => {
  return (
    <div className="users-container">
      <h1 className="page-title">Users</h1>
      <div className="users-content">
        <p>Users management page - Coming soon</p>
        <p>This page will display a list of all users with their details.</p>
      </div>
    </div>
  );
};

export default Users;
